import {
  Component,
  OnInit,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from "@angular/core";
import { FormControl } from "@angular/forms";
import { Observable } from "rxjs";
import { switchMap, debounceTime, tap, finalize } from "rxjs/operators";
import { FormBuilder, FormGroup } from "@angular/forms";
import { SaleService } from "../../../services/sale.service";
import { GuiGuard } from "../../../shared/guard/base-gui-guard";
import { map, startWith } from "rxjs/operators";
import { MasterItem } from "../../../models/masterItem";
import { ManuracturerService } from "../../../services/manuracturer.service";
import { InventoryCategoryService } from "../../../services/inventory-category.service";
import { Methods } from "../../../shared/methods";
import { MasterItemsService } from "../../../services/master-items.service";
import { UserService } from "../../../services/user.service";
import { ViewChild } from "@angular/core";
import { MatAutocompleteTrigger } from "@angular/material/autocomplete";
import { Router } from "@angular/router";
import swal from "sweetalert2";

declare const $: any;

export interface List {
  id: number;
  name: string;
  item: string;
  mfgr: string;
  clei: boolean;
  bulk: boolean;
  nonInventory: boolean;
  unitprice: string;
  unitcost: string;
  masteritem_id: number;
  master: any;
  descripcion: string;
  extendedDescription: string;
  weight: string;
  isScrap: number;
  scrapNotes: string;
  mfgr_id: any;
  warehouse_id: any;
  inventorycategory_id: any;
  inventorycategory_id2: any;
  inventorycategory_id3: any;
  inventorycategory_id4: any;
  mastertypes_id: any;
  location_id: any;
}

@Component({
  selector: "app-filter-line-items",
  templateUrl: "./filter-line-items.component.html",
  styleUrls: ["./filter-line-items.component.css"],
  providers: [
    SaleService,
    UserService,
    MasterItemsService,
    ManuracturerService,
    InventoryCategoryService,
  ],
})
export class FilterLineItemsComponent implements OnInit {
  @ViewChild(MatAutocompleteTrigger)
  autocompleteTrigger: MatAutocompleteTrigger;

  closeAutocomplete() {
    this.autocompleteTrigger.closePanel();
  }
  public identity;
  public mtds: Methods = new Methods();
  @Input() id: "filter";
  @Input() type: "Inventory";
  @Input() bulk: number = 0;
  @Input() cerrar: number = 0;
  @Input() crear: boolean = true;
  @Input() weightRequired: number = 0;
  @Input() hideNewMaster: number = 0;
  @Output() select: EventEmitter<any>;

  @Input() showNonInventory: number = 0;

  @Input() previusearch: "";
  @Input() value: any = null;

  filteredOptions: Observable<string[]>;
  public filteredClientes: any;
  usersForm: FormGroup;
  public myControl = new FormControl();
  public optionSelected = "";
  public data;
  options: List[] = [];
  public mgftList: any[] = [];
  public categories1: any[] = [];
  public categories2: any[] = [];
  public categories3: any[] = [];
  public categories4: any[] = [];

  public searchLevel1 = "";
  public searchLevel2 = "";
  public searchLevel3 = "";
  public searchLevel4 = "";

  public loadingLevel1 = false;
  public loadingLevel2 = false;
  public loadingLevel3 = false;
  public loadingLevel4 = false;

  public x: any;

  public nuevo = false;
  public saving = false;
  public savingMfgr = false;
  public count = 0;

  public loading = false;
  public loadingSyncMfgr: boolean = false;

  public masterItem: MasterItem = new MasterItem();

  public nuevaC1 = "";
  public nuevaC2 = "";
  public nuevaC3 = "";
  public nuevaC4 = "";

  public saveC1 = false;
  public saveC2 = false;
  public saveC3 = false;
  public saveC4 = false;
  public loadingAI: boolean = false;

  public first = true;

  public nuevoMaster = {
    value: "newMaster",
    name: "New Master Item",
  };

  public quickMaster = {
    value: "quickMaster",
    name: "Quick Enter",
  };

  public mfgr = {
    name: "",
    fullname: "",
  };

  public valor = "";

  constructor(
    public guard: GuiGuard,
    private _router: Router,
    private _inventoryCategorieServices: InventoryCategoryService,
    private _mfgrService: ManuracturerService,
    private fb: FormBuilder,
    private _saleService: SaleService,
    private _masterItemSErvices: MasterItemsService,
    private _userService: UserService
  ) {
    this.select = new EventEmitter();

    let identity, token;
    identity = JSON.parse(localStorage.getItem("identity"));

    this.identity = this._userService.getIdentity();
  }

  ngOnChanges(changes: any): void {
    console.log(changes);
    if (this.cerrar) {
      this.closeAutocomplete();
    }

    this.nuevo = false;
  }

  buscar() {
    console.log(this.valor);
  }

  ngOnInit() {
    this.usersForm = this.fb.group({
      userInput: null,
    });

    if (this.bulk) {
      console.log(this.bulk);
      this.masterItem.bulk = true;
    }

    this.usersForm
      .get("userInput")
      .valueChanges.pipe(
        debounceTime(300),
        tap(() => (this.loading = true)),
        switchMap((value) =>
          this._saleService
            .searchPart(
              typeof value === "string" ? value : "",
              this.bulk,
              this.showNonInventory
            )
            .pipe(finalize(() => (this.loading = false)))
        )
      )
      .subscribe((response) => {
        this.x = response;
        console.log(this.x.data);
        let element;
        this.options = [];
        for (element of this.x.data) {
          let nameOption = element.partNumber + " / " + element.mfgr.name;
          if (element.inventoryCategory && element.inventoryCategory.name)
            nameOption = nameOption + " # " + element.inventoryCategory.name;
          this.options.push({
            id: element.id,
            name: nameOption,
            item: element.partNumber,
            mfgr: element.mfgr.name,
            clei: this.booleanConvert(element.clei),
            bulk: this.booleanConvert(element.bulk),
            nonInventory: this.booleanConvert(element.nonInventory),
            unitprice: element.unitprice,
            unitcost: element.unitcost,
            masteritem_id: element.id,
            master: null,
            descripcion: element.descripcion,
            extendedDescription: element.extDescripcion,
            weight: element.weight,
            isScrap: element.isScrap,
            scrapNotes: element.scrapNotes,
            mfgr_id: element.mfgr !== null ? element.mfgr.id : "",
            warehouse_id:
              element.warehouse !== null ? element.warehouse.id : "",
            inventorycategory_id:
              element.inventoryCategory !== null
                ? element.inventoryCategory.id
                : null,
            inventorycategory_id2:
              element.inventoryCategory2 !== null
                ? element.inventoryCategory2.id
                : null,
            inventorycategory_id3:
              element.inventoryCategory3 !== null
                ? element.inventoryCategory3.id
                : null,
            inventorycategory_id4:
              element.inventoryCategory4 !== null
                ? element.inventoryCategory4.id
                : null,
            mastertypes_id:
              element.masterTypes !== null ? element.masterTypes.id : "",
            location_id: element.location !== null ? element.location.id : "",
          });
        }
        this.filteredClientes = this.myControl.valueChanges.pipe(
          startWith<string | List>(""),
          map((value) => (typeof value === "string" ? value : value.name)),
          map((name) => (name ? this._filter(name) : this.options.slice()))
        );

        // console.log(this.options);

        // if (this.first && this.previusearch && this.value) {
        //   for (let option of this.options) {
        //     if (option.id == this.value) {
        //       console.log(option);
        //       this.myControl.setValue(option);
        //       break;
        //     }
        //   }
        // }
        // this.previusearch = '';
        // this.first = false;
      });

    //       this.usersForm.valueChanges
    //         .pipe(startWith()).subscribe(value =>
    //         {
    //             console.log(value)
    //         });

    // if (this.previusearch) {
    //   this.usersForm.setValue( {userInput: this.previusearch});
    // }
    // this.usersForm.setValue( {userInput: 'l'});

    // this.usersForm.updateValueAndValidity({ onlySelf: false, emitEvent: true });

    $("#nuevomfgrmodal").on("hidden.bs.modal", () => {
      console.log("Se detecto cierre de modal");
      this.mfgr = {
        name: "",
        fullname: "",
      };
    });
  }

  selectMfgr(e) {
    console.log(e);

    if (this.masterItem.partNumber) {
      // Buscar el nombre del fabricante basado en el ID.
      // const selectedMfgr = this.mgftList.find(mfgr => mfgr.id === e);
      const selectedMfgr = e;

      if (selectedMfgr) {
        console.log("Selected Manufacturer Name => ", selectedMfgr.name);

        this.loading = true;
        this.loadingAI = true;
        this._masterItemSErvices
          .getCategoryByAI(this.masterItem.partNumber, selectedMfgr.name)
          .subscribe(
            (response) => {
              this.loading = false;
              this.loadingAI = false;
              if (response.result == "success") {
                this.masterItem.weight = response.responseWeight;

                const selectedCategory = this.categories1.find(
                  (cat) => cat.name === response.responseCategory
                );
                if (selectedCategory) {
                  this.selectLevel1(selectedCategory);
                } else {
                  console.log("No category found matching response data");
                }
              }
            },
            (error) => {
              this.loading = false;
              this.loadingAI = false;
              console.log("error => ", error);
            }
          );
      }
    }

    if (e.id) {
      this.masterItem.mfgr_id = e.id;
    } else {
      $("#nuevomfgrmodal").modal("show");
    }
  }

  syncmfgr() {
    let me = this;
    this.loadingSyncMfgr = true;
    this._mfgrService.syncMfgr().subscribe((response) => {
      me._mfgrService.showAll().subscribe((response) => {
        me.mgftList = response.data;
      });
      me.loadingSyncMfgr = false;
    });
  }
/*
  isWeightInvalid:boolean = false;
  onWeightChange() {
  this.isWeightInvalid = !this.masterItem.weight || Number(this.masterItem.weight) === 0;
  console.log("onWeightChange => isWeightInvalid", this.isWeightInvalid);
}*/

  isWeightInvalid(): boolean {
    const weight = this.masterItem.weight;

    if (weight == null || weight === '') {
      return true; // Si es null, undefined o vacío, es inválido
    }

    return Number(weight) === 0 || (typeof weight === 'string' && weight.trim() === '0');
  }


  saveMfgr() {
    this.savingMfgr = true;
    this._mfgrService.create(this.mfgr).subscribe(
      (response) => {
        if (response.code === 200) {
          this.closeModal();
          //open modal

          this.mgftList.push(response.data);
          this.masterItem.mfgr_id = response.data.id;
          // this.getAll();

          swal.fire({
            title: "Manufacturer has been saved successfully",
            text: "",
            buttonsStyling: false,
            customClass: {
              confirmButton: "btn btn-success",
            },
          });
        } else if (response.code === 400) {
          localStorage.clear();
          this._router.navigate(["/pages/lock"]);
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
        setTimeout(() => {
          this.savingMfgr = false;
        }, 300);
      },
      (error) => {
        this.savingMfgr = false;
        console.log("Error!");
      }
    );
  }

  closeModal() {
    $("#nuevomfgrmodal").hide();
  }

  nuevoMasterItem(non_inventory = false) {
    this.masterItem = new MasterItem();
    this.masterItem.bulk = this.bulk === 1;
    this.masterItem.non_inventory = non_inventory;
    this.nuevo = true;
    if (this.mgftList.length === 0) {
      this._mfgrService.showAll().subscribe((response) => {
        this.mgftList = response.data;
      });
    }
    if (this.categories1.length === 0) {
      this._inventoryCategorieServices.showAll().subscribe((response) => {
        this.categories1 = response.data;
      });
    }
  }

  buscarLevel1(level1) {
    if (
      this.searchLevel1 == "" ||
      level1.toUpperCase().includes(this.searchLevel1.toUpperCase())
    )
      return true;
    return false;
  }

  selectLevel1(categorie) {
    this.masterItem.inventorycategory_id2 = null;
    this.masterItem.inventorycategory_id3 = null;
    this.masterItem.inventorycategory_id4 = null;

    this.categories2 = [];
    this.categories3 = [];
    this.categories4 = [];

    if (categorie.id !== this.masterItem.inventorycategory_id) {
      this.masterItem.inventorycategory_id = categorie.id;
      this.loadingLevel2 = true;
      this._inventoryCategorieServices.showAll(categorie.id, 2).subscribe(
        (response) => {
          console.log(response);
          this.categories2 = response.data;
          this.loadingLevel2 = false;
        },
        (error) => {
          this.loadingLevel2 = false;
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
    } else {
      this.masterItem.inventorycategory_id = null;
    }
  }

  categoria1() {
    let categoria;
    for (categoria of this.categories1) {
      if (categoria.id == this.masterItem.inventorycategory_id) {
        return categoria.name;
      }
    }
    return "Category 1*";
  }

  buscarLevel2(level2) {
    if (
      this.searchLevel2 == "" ||
      level2.toUpperCase().includes(this.searchLevel2.toUpperCase())
    )
      return true;
    return false;
  }

  selectLevel2(categorie) {
    this.masterItem.inventorycategory_id3 = null;
    this.masterItem.inventorycategory_id4 = null;

    this.categories3 = [];
    this.categories4 = [];

    if (categorie.id !== this.masterItem.inventorycategory_id2) {
      this.masterItem.inventorycategory_id2 = categorie.id;
      this.loadingLevel3 = true;
      this._inventoryCategorieServices.showAll(categorie.id, 3).subscribe(
        (response) => {
          console.log(response);
          this.categories3 = response.data;
          this.loadingLevel3 = false;
        },
        (error) => {
          this.loadingLevel3 = false;
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
    } else {
      this.masterItem.inventorycategory_id2 = null;
    }
  }

  categoria2() {
    let categoria;
    for (categoria of this.categories2) {
      if (categoria.id == this.masterItem.inventorycategory_id2) {
        return categoria.name;
      }
    }
    return "Category 2";
  }

  buscarLevel3(level3) {
    if (
      this.searchLevel3 == "" ||
      level3.toUpperCase().includes(this.searchLevel3.toUpperCase())
    )
      return true;
    return false;
  }

  selectLevel3(categorie) {
    this.masterItem.inventorycategory_id4 = null;

    this.categories4 = [];

    if (categorie.id !== this.masterItem.inventorycategory_id3) {
      this.masterItem.inventorycategory_id3 = categorie.id;
      this.loadingLevel4 = true;
      this._inventoryCategorieServices.showAll(categorie.id, 4).subscribe(
        (response) => {
          console.log(response);
          this.categories4 = response.data;
          this.loadingLevel4 = false;
        },
        (error) => {
          this.loadingLevel4 = false;
          this.mtds.notifyError(error.statusText, error.status);
        }
      );
    } else {
      this.masterItem.inventorycategory_id3 = null;
    }
  }

  categoria3() {
    let categoria;
    for (categoria of this.categories3) {
      if (categoria.id == this.masterItem.inventorycategory_id3) {
        return categoria.name;
      }
    }
    return "Category 3";
  }

  dosclicks() {
    console.log("dummy");
  }

  buscarLevel4(level4) {
    if (
      this.searchLevel4 == "" ||
      level4.toUpperCase().includes(this.searchLevel4.toUpperCase())
    )
      return true;
    return false;
  }

  selectLevel4(categorie) {
    if (categorie.id !== this.masterItem.inventorycategory_id4) {
      this.masterItem.inventorycategory_id4 = categorie.id;
    } else {
      this.masterItem.inventorycategory_id4 = null;
    }
  }

  categoria4() {
    let categoria;
    for (categoria of this.categories4) {
      if (categoria.id == this.masterItem.inventorycategory_id4) {
        return categoria.name;
      }
    }
    return "Category 4";
  }

  back() {
    this.masterItem = new MasterItem();
    this.nuevo = false;
  }

  save() {
    this.masterItem.non_inventory = this.showNonInventory === 1;

    this.saving = true;
    this._masterItemSErvices.create(this.masterItem).subscribe(
      (response) => {
        this.saving = false;
        // console.log(response);
        if (response.code === 200) {
          this.select.emit({
            id: response.data.id,
            name: response.data.partNumber + " / " + response.data.mfgr.name,
            item: response.data.partNumber,
            mfgr: response.data.mfgr.name,
            clei: this.booleanConvert(response.data.clei),
            bulk: this.booleanConvert(response.data.bulk),
            nonInventory: this.booleanConvert(response.data.nonInventory),
            unitprice: response.data.unitprice,
            unitcost: response.data.unitcost,
            masteritem_id: response.data.id,
            master: null,
            descripcion: response.data.descripcion,
            extendedDescription: response.data.extDescripcion,
            weight: response.data.weight,
            isScrap: response.data.isScrap,
            scrapNotes: response.data.scrapNotes,
            mfgr_id: response.data.mfgr !== null ? response.data.mfgr.id : "",
            warehouse_id:
              response.data.warehouse !== null
                ? response.data.warehouse.id
                : "",
            inventorycategory_id:
              response.data.inventoryCategory !== null
                ? response.data.inventoryCategory.id
                : null,
            inventorycategory_id2:
              response.data.inventoryCategory2 !== null
                ? response.data.inventoryCategory2.id
                : null,
            inventorycategory_id3:
              response.data.inventoryCategory3 !== null
                ? response.data.inventoryCategory3.id
                : null,
            inventorycategory_id4:
              response.data.inventoryCategory4 !== null
                ? response.data.inventoryCategory4.id
                : null,
            mastertypes_id:
              response.data.masterTypes !== null
                ? response.data.masterTypes.id
                : "",
            location_id:
              response.data.location !== null ? response.data.location.id : "",
          });
          this.nuevo = false;
        } else {
          this.mtds.notifyError(response.msg, response.code);
        }
      },
      (error) => {
        this.saving = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  booleanConvert(item) {
    return item !== 0 && item !== "0" && item !== false && item !== null;
  }

  private _filter(name: string): List[] {
    const filterValue = name.toLowerCase();
    return this.options.filter((option) =>
      option.name.toLowerCase().includes(filterValue)
    );
  }

  displayFn(user?: List): string | undefined {
    return user ? user.name : undefined;
  }

  OnHumanSelected(option) {
    console.log(option);

    if (option.value.value === "newMaster") {
      this.nuevoMasterItem();
    }
    // else if (option.value.value === 'quickMaster') {
    //   this.nuevoMasterItem(true);
    //  }
    else {
      this.select.emit(option.value);
    }
  }

  newCategory(name, father, level) {
    let json = {
      name: name,
      idfather: String(father),
      level: String(level),
    };
    switch (level) {
      case 1:
        this.saveC1 = true;
        break;
      case 2:
        this.saveC2 = true;
        break;
      case 3:
        this.saveC3 = true;
        break;
      case 4:
        this.saveC4 = true;
        break;
      default:
        break;
    }

    this._inventoryCategorieServices.create(json).subscribe(
      (r) => {
        if (r.code === 200) {
          this.exito(level, r.data);
        } else {
          this.mtds.notifyError("Error: " + r.msg);
        }
        this.saveC1 = false;
        this.saveC2 = false;
        this.saveC3 = false;
        this.saveC4 = false;
      },
      (error) => {
        this.mtds.notifyError(error.statusText, error.status);
        this.saveC1 = false;
        this.saveC2 = false;
        this.saveC3 = false;
        this.saveC4 = false;
      }
    );
  }

  getCategories1() {
    this._inventoryCategorieServices.showAll().subscribe((response) => {
      this.categories1 = response.data;
    });
  }

  getCategories2(father) {
    this._inventoryCategorieServices.showAll(father, 2).subscribe(
      (response) => {
        this.categories2 = response.data;
        this.loadingLevel2 = false;
      },
      (error) => {
        this.loadingLevel2 = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  getCategories3(father) {
    this._inventoryCategorieServices.showAll(father, 3).subscribe(
      (response) => {
        this.categories3 = response.data;
        this.loadingLevel3 = false;
      },
      (error) => {
        this.loadingLevel3 = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  getCategories4(father) {
    this._inventoryCategorieServices.showAll(father, 4).subscribe(
      (response) => {
        this.categories4 = response.data;
        this.loadingLevel4 = false;
      },
      (error) => {
        this.loadingLevel4 = false;
        this.mtds.notifyError(error.statusText, error.status);
      }
    );
  }

  async exito(level, category) {
    switch (level) {
      case 1:
        this.nuevaC1 = "";
        await this.getCategories1();
        await this.selectLevel1(category);
        break;
      case 2:
        this.nuevaC2 = "";
        await this.getCategories2(this.masterItem.inventorycategory_id);
        await this.selectLevel2(category);
        break;
      case 3:
        this.nuevaC3 = "";
        await this.getCategories3(this.masterItem.inventorycategory_id2);
        await this.selectLevel3(category);
        break;
      case 4:
        this.nuevaC4 = "";
        await this.getCategories4(this.masterItem.inventorycategory_id3);
        await this.selectLevel4(category);
        break;
      default:
        break;
    }
  }
}
